import React, {useEffect, useState} from "react";

import './ShiftsTable.scss'
import {useRecoilValue} from "recoil";
import {grpcShiftServiceSelector} from "../../state/grpc";
import {ADD, useToastContext} from "../Toast";
import {
  DataTableSkeleton,
  Loading,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  TextInput,
  Toggle
} from "@carbon/react";

const ShiftsTable = () => {
  const {toastDispatch} = useToastContext();
  const shiftService = useRecoilValue(grpcShiftServiceSelector)
  const [loading, setLoading] = useState(true)
  const [shifts, setShifts] = useState([])
  const [error, setError] = useState(false)
  const [toggleLoading, setToggleLoading] = useState(false)

  const loadShifts = async () => {
    const req = new proto.api.ListShiftsRequest()
    shiftService.listShifts(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        setError(true)
      } else {
        setShifts(resp.toObject().shiftsList)
      }
      setLoading(false)
    })
  }

  useEffect(() => {
    loadShifts()
  }, [])

  if (loading) {
    return (<DataTableSkeleton
      columnCount={5}
      rowCount={5}
    />)
  }

  if (error) {
    return (<div>
      <span>ERROR!</span>
    </div>)
  }

  const headers = [{
    key: 'username', header: 'Utente'
  }, {
    key: 'email', header: 'Email'
  }, {
    key: 'updatedAt', header: 'Ultimo aggiornamento'
  }, {
    key: 'updatedBy', header: 'Modificato da'
  }, {
    key: 'enabled', header: 'Di turno'
  }, {
    key: 'mailEnabled', header: 'E-mail'
  }, {
    key: 'appEnabled', header: 'WakeUp'
  }];

  const onShiftToggle = (shift, toggled) => {
    setToggleLoading(true)
    const req = new proto.api.SaveShiftRequest()
    const shiftReq = new proto.api.Shift()
    shiftReq.setId(shift.id)
    shiftReq.setUsername(shift.username)
    shiftReq.setEmail(shift.email)
    shiftReq.setEnabled(toggled)
    shiftReq.setEmailNotification(shift.emailNotification)
    shiftReq.setAppNotification(shift.appNotification)
    req.setShift(shiftReq)
    updateRemoteShift(req)
  }

  const onMailToggle = (shift, toggled) => {
    setToggleLoading(true)
    const req = new proto.api.SaveShiftRequest()
    const shiftReq = new proto.api.Shift()
    shiftReq.setId(shift.id)
    shiftReq.setUsername(shift.username)
    shiftReq.setEmail(shift.email)
    shiftReq.setEnabled(shift.enabled)
    shiftReq.setEmailNotification(toggled)
    shiftReq.setAppNotification(shift.appNotification)
    req.setShift(shiftReq)
    updateRemoteShift(req)
  }

  const onAppToggle = (shift, toggled) => {
    setToggleLoading(true)
    const req = new proto.api.SaveShiftRequest()
    const shiftReq = new proto.api.Shift()
    shiftReq.setId(shift.id)
    shiftReq.setUsername(shift.username)
    shiftReq.setEmail(shift.email)
    shiftReq.setEnabled(shift.enabled)
    shiftReq.setEmailNotification(shift.emailNotification)
    shiftReq.setAppNotification(toggled)
    req.setShift(shiftReq)
    updateRemoteShift(req)
  }

  const updateRemoteShift = (req) => {
    shiftService.saveShift(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        toastDispatch({
          type: ADD,
          payload: {
            title: "Operazione fallita",
            content: "Impossibile salvare il turno",
            kind: "error",
            caption: err.message
          }
        })
      } else {
        loadShifts()
      }
      setToggleLoading(false)
    })
  }

  return (
    <>
      { toggleLoading && <Loading withOverlay={true} /> }
      <Table size="lg" useZebraStyles={false}>
        <TableHead>
          <TableRow>
            {headers.map((header) => (
              <TableHeader id={header.key} key={header.key}>
                {header.header}
              </TableHeader>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {shifts.map((row) => (
            <TableRow key={row.id}>
              <TableCell key="username">{row.username}</TableCell>
              <TableCell key="email">
                <TextInput
                  id="shift-email"
                  labelText=""
                  disabled={row.enabled}
                  title={row.enabled ? "Chiudi il turno se vuoi modificare l'indirizzo email" : ""}
                  placeholder={row.email}
                  onChange={(ev) => {
                    row.email = ev.target.value
                  }}/>
              </TableCell>
              <TableCell key="updatedat">{row.updatedat}</TableCell>
              <TableCell key="updatedby">{row.updatedby}</TableCell>
              <TableCell key="enabled">
                <Toggle
                  id="shift-enabled"
                  labelA="No"
                  labelB="Si"
                  toggled={row.enabled}
                  onToggle={(toggled) => onShiftToggle(row, toggled)}
                />
              </TableCell>
              <TableCell key="mailEnabled">
                <Toggle
                  id="mail-enabled"
                  labelA="No"
                  labelB="Si"
                  toggled={row.emailNotification}
                  onToggle={(toggled) => onMailToggle(row, toggled)}
                />
              </TableCell>
              <TableCell key="appEnabled">
                <Toggle
                  id="app-enabled"
                  labelA="No"
                  labelB="Si"
                  toggled={row.appNotification}
                  onToggle={(toggled) => onAppToggle(row, toggled)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  )
}

export default ShiftsTable